export default __webpack_public_path__ + "static/media/pottery1.8f13aee1.jpg";